module.exports = __webpack_public_path__ + "img/scenario-scout.1170c58.svg";